import React from "react";
import { Calendar, Vote } from "lucide-react";

export const ElectionCountdown = () => {
  const now = new Date();
  const until = (d) => Math.ceil((d - now) / 86400000);
  const evStart = new Date(2026, 6, 17);
  const evEnd = new Date(2026, 7, 2);
  const eDay = new Date(2026, 7, 6);
  if (now >= new Date(2026, 7, 7)) return null;
  const edays = until(eDay);
  return (
    <div className="flex flex-wrap gap-2 mb-2" data-testid="election-countdown">
      {now < evStart ? (
        <span className="inline-flex items-center gap-1.5 bg-amber-400/20 border border-amber-400 text-amber-300 font-black text-[11px] px-3 py-1 rounded-full" data-testid="countdown-early-voting">
          <Calendar className="w-3 h-3" /> EARLY VOTING STARTS IN {until(evStart)} DAY{until(evStart) === 1 ? "" : "S"}
        </span>
      ) : now < evEnd ? (
        <span className="inline-flex items-center gap-1.5 bg-amber-400 text-slate-900 font-black text-[11px] px-3 py-1 rounded-full animate-pulse" data-testid="countdown-early-voting">
          <Calendar className="w-3 h-3" /> EARLY VOTING IS OPEN · {until(evEnd)} DAY{until(evEnd) === 1 ? "" : "S"} LEFT
        </span>
      ) : null}
      {edays > 0 ? (
        <span className="inline-flex items-center gap-1.5 bg-red-600 text-white font-black text-[11px] px-3 py-1 rounded-full" data-testid="countdown-election-day">
          <Vote className="w-3 h-3" /> ELECTION DAY · AUG 6 · {edays} DAY{edays === 1 ? "" : "S"} AWAY
        </span>
      ) : (
        <span className="inline-flex items-center gap-1.5 bg-red-600 text-white font-black text-[11px] px-3 py-1 rounded-full animate-pulse" data-testid="countdown-election-day">
          <Vote className="w-3 h-3" /> ELECTION DAY IS TODAY — GO VOTE!
        </span>
      )}
    </div>
  );
};
